import axios from 'axios'
import { DocumentJobProducer, DocumentPipelineAuditFilters, DocumentPipelineAuditResponse } from '@numeo/types-core'

/** How each producer reads in the filter. Keyed by the shared enum, so a producer added there must be labelled here. */
export const PIPELINE_PRODUCER_LABELS: Record<DocumentJobProducer, string> = {
    [DocumentJobProducer.RATECON_EMAIL_SHADOW]: 'Email ratecons (shadow)',
    [DocumentJobProducer.RATECON_EMAIL]: 'Email ratecons (live)',
    [DocumentJobProducer.IMMEDIATE_API]: 'Immediate API',
    [DocumentJobProducer.GLUON_TEST]: 'Gluon test page',
}

/** The message to show for a failed call: the server's own message when it sent one, else the fallback. */
/** Re-exported, not re-implemented — see `@/api/errorMessage`. Behaviour is unchanged. */
export { apiErrorMessage } from '@/api/errorMessage'

export const pipelineAuditApi = {
    async getAudit(filters: DocumentPipelineAuditFilters): Promise<DocumentPipelineAuditResponse> {
        const res = await axios.get('/gluon/document-jobs/audit/v1', { params: filters })
        return res.data.data as DocumentPipelineAuditResponse
    },
}
